import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../../components/CustomComponents/CustomViewPage'
import { useTrainingCategoryContent } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategoryContent'
import ViewImage from '../../../components/ViewImage'
import ViewPdf from '../../../components/ViewPdf'
import { formatDate } from '../../../shared/constants'

export default function ViewTrainingCategoryContent() {
  const { getTrainingCategoryContent, trainingCategoryContent, loading } = useTrainingCategoryContent()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getTrainingCategoryContent({ _id: params.trainingCategoryContentId })
  }, [params.trainingCategoryContentId])

  useEffect(() => {
    if (trainingCategoryContent) {
      setData([
        { label: 'Training Category Content Code', data: trainingCategoryContent.trainingCategoryContentCode },
        { label: 'Name', data: `${trainingCategoryContent.name}` },
        { label: 'Training Category', data: `${trainingCategoryContent.trainingCategory && trainingCategoryContent.trainingCategory.name}` },
        { label: 'Search Tags', data: trainingCategoryContent.metaTags },
        { label: 'Start Date', data: formatDate(trainingCategoryContent.startDate) },
        { label: 'Expiry Date', data: formatDate(trainingCategoryContent.expiryDate) },

        // { label: 'Thumbnail', data: <ViewImage image={trainingCategoryContent.contentThumbnail} /> },
        // { label: 'Video', data: <ViewImage image={trainingCategoryContent.video} /> },
        // { label: 'PDF', data: <ViewPdf image={trainingCategoryContent.pdf} /> },
        // { label: 'PPT', data: <ViewPdf image={trainingCategoryContent.ppt} /> },
      ])
    }
  }, [trainingCategoryContent])
  return (
    <CustomViewPage
      loading={loading}
      heading="Training Category Content"
      editUrl="training-category-content"
      id={params.trainingCategoryContentId}
      redirect="ALL_TRAININGCATEGORYCONTENT"
      data={data}
    />
  )
}
